export const GET_HOSTED_PAGE_REQUEST = 'GET_HOSTED_PAGE_REQUEST';
export const GET_HOSTED_PAGE_SUCCESS = 'GET_HOSTED_PAGE_SUCCESS';
export const GET_HOSTED_PAGE_FAILURE = 'GET_HOSTED_PAGE_FAILURE';

export const GET_CREDENTIAL_FROM_HOSTED_PAGE_REQUEST = 'GET_CREDENTIAL_FROM_HOSTED_PAGE_REQUEST';
export const GET_CREDENTIAL_FROM_HOSTED_PAGE_SUCCESS = 'GET_CREDENTIAL_FROM_HOSTED_PAGE_SUCCESS';
export const GET_CREDENTIAL_FROM_HOSTED_PAGE_FAILURE = 'GET_CREDENTIAL_FROM_HOSTED_PAGE_FAILURE';

export const getHostedPageRequest = data => ({
  type: GET_HOSTED_PAGE_REQUEST,
  params: {
    data,
  },
});

export const getHostedPageSuccess = hostedPage => ({
  type: GET_HOSTED_PAGE_SUCCESS,
  payload: hostedPage,
});

export const getHostedPageFailure = error => ({
  type: GET_HOSTED_PAGE_FAILURE,
  payload: {
    error,
  },
});

export const getCredentialFromHostedPageRequest = payload => ({
  type: GET_CREDENTIAL_FROM_HOSTED_PAGE_REQUEST,
  payload,
});

export const getCredentialFromHostedPageSuccess = credential => ({
  type: GET_CREDENTIAL_FROM_HOSTED_PAGE_SUCCESS,
  payload: credential,
});

export const getCredentialFromHostedPageFailure = error => ({
  type: GET_CREDENTIAL_FROM_HOSTED_PAGE_FAILURE,
  payload: {
    error,
  },
});
